(function () {
  'use strict';

  var root = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(max-width: 768px)').matches) return;

  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function once(el, key) {
    if (!el) return false;
    var k = 'animInit' + key;
    if (el.dataset[k]) return false;
    el.dataset[k] = '1';
    return true;
  }

  function inFirstScreen(el) {
    var r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < window.innerHeight;
  }

  function reveal(el) {
    el.classList.add('is-inview');
    el.dispatchEvent(new CustomEvent('animate:revealed', { bubbles: true }));
  }

  var singleObserver = reduceMotion ? null : new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      reveal(entry.target);
      singleObserver.unobserve(entry.target);
    });
  }, { root: null, rootMargin: '0px 0px -8% 0px', threshold: 0.12 });

  function initSingles(ctx) {
    qsa('[data-animate]', ctx).forEach(function (el) {
      if (el.closest('[data-animate-group]')) return;
      if (el.classList.contains('is-inview')) return;
      if (!once(el, 'Single')) return;
      if (reduceMotion) { reveal(el); return; }
      var delay = parseInt(el.dataset.animateDelay, 10) || 0;
      if (delay) el.style.transitionDelay = delay + 'ms';
      singleObserver.observe(el);
    });
  }

  function initGroups(ctx) {
    qsa('[data-animate-group]', ctx).forEach(function (group) {
      if (!once(group, 'Group')) return;
      var items = qsa('[data-animate-item]', group).filter(function (item) { return item.closest('[data-animate-group]') === group; });
      if (!items.length) return;
      if (reduceMotion) { items.forEach(reveal); return; }
      var stagger = parseInt(group.dataset.animateStagger, 10) || 80;
      var cap = parseInt(group.dataset.animateStaggerCap, 10) || 6;
      items.forEach(function (item, i) {
        item.style.transitionDelay = (Math.min(i, cap) * stagger) + 'ms';
      });
      var groupObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          items.forEach(reveal);
          groupObserver.disconnect();
        });
      }, { root: null, rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      groupObserver.observe(group);
    });
  }

  function initAll(ctx) {
    if (!root.classList.contains('animations-ready')) {
      // Pehle fold ke andar wale elements reveal karo, PHIR hide-class lagao
      qsa('[data-animate], [data-animate-item]', ctx).forEach(function (el) {
        if (inFirstScreen(el)) reveal(el);
      });
      root.classList.add('animations-ready');
    }
    initSingles(ctx);
    initGroups(ctx);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
    qsa('[data-animate], [data-animate-item]', e.target).forEach(reveal);
  });
})();